
<script>
import Formserachauthorization from '@/views/private/finance/expenses/travelrefund/formserachauthorization/formserachauthorization.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import TetoRelatorioLotes from '@/shared/mixins/tetoRelatorioLotes'
import Tools from '@/components/tools/Tools.js'
import detailsModal from './components/detailsModal.vue'
import filterForm from './components/filterForm.vue'
import reportLotsPdf from './components/reportLotsPdf.vue'
import { derivaConsulta } from '@/views/private/finance/expenses/travelexpensezpag/rolesEscritaViagem'

const name = 'CollaboratorTableTravelExpenseEmploye'

export default {
  name,
  mixins: [ActionsForm, TetoRelatorioLotes],
  components: { detailsModal, Formserachauthorization, filterForm, reportLotsPdf },

  props: {

  },

  mounted () {
  },

  updated () { },

  data () {
    return {
      pedido: null,
      PedidoGerado: false,
      details: [],
      detailsProp: [],
      loteId: null,
      collabId: '',
      funcionarioId: null,
      partId: '',
      partStartDate: '',
      partEndDate: '',
      partNumber: 0,
      totalPartValue: 0,
      dataFormatada: null,
      // loteIDs marcados. Array separado em vez de `detail.selecionado`: `details` vem da API e
      // propriedade nova em objeto ja criado nao e reativa no Vue 2 sem $set.
      selecionados: [],
      // "selecionar todos" NAO e "marcar as linhas visiveis". A grid mostra 10 e o colaborador
      // pode ter 57 lotes (medido), sem paginador -- mapear `details` entregava 10 de 57, e o
      // pedido era justamente todos. Neste modo o body vai com `LoteIds: []`, que o backend le
      // como TODOS os lotes do colaborador.
      todosOsLotes: false
    }
  },

  methods: {
    // seleção de lotes (ZC-42) ------------------------------------------------------------
    alternarLote (loteID) {
      // mexer numa linha sai do modo "todos": a partir daqui vale a lista explícita
      this.todosOsLotes = false
      const i = this.selecionados.indexOf(loteID)
      if (i >= 0) { this.selecionados.splice(i, 1); return }
      // ZC-46: o teto é checado AQUI também, e não só no `:disabled` do checkbox. Aparência
      // não é regra -- e sair do modo "todos" já mexeu no estado antes desta linha.
      const detail = (this.details || []).find(d => d.loteID === loteID)
      if (!this.podeMarcarLote(detail)) return
      this.selecionados.push(loteID)
    },

    // O Tables.vue emite 'check' com o INPUT do cabeçalho (Tables.vue:69), não com um boolean.
    //
    // Aqui NÃO mapeamos `this.details`: ele é só a página atual (10 linhas, sem paginador na
    // tela), e o colaborador medido tem 57 lotes. Marcar o cabeçalho liga o modo `todosOsLotes`,
    // que manda `LoteIds: []` — o backend trata vazio como TODOS.
    marcarTodos (input) {
      this.todosOsLotes = !!(input && input.checked)
      this.selecionados = []
    },

    // Um PDF com os comprovantes dos lotes marcados. Acima do teto do servidor a resposta é 413,
    // e a mensagem dele diz quanto passou -- por isso o catch LÊ o corpo em vez de trocar tudo
    // por um toast genérico: com responseType 'blob', o erro chega como Blob e precisa de .text().
    async gerarRelatorioSelecionados () {
      if (!this.todosOsLotes && !this.selecionados.length) return
      // ZC-46: teto de anexo/lote. Fica aqui também porque o `:disabled` do botão é aparência.
      if (this.motivoTetoRelatorio) { toast.error(this.motivoTetoRelatorio); return }

      loading.push()
      try {
        const Response = await TravelExpenseRepository.GerarPDFComprovantesFuncionario({
          FuncionarioId: this.collabId,
          EmpresaId: this.CompanySelected,
          // vazio = TODOS, e e assim que o "selecionar todos" alcanca lote que a tela nem mostra
          LoteIds: this.todosOsLotes ? [] : this.selecionados
        })

        const fileURL = window.URL.createObjectURL(new Blob([Response.data], {type: 'application/pdf'}))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        const sufixo = this.todosOsLotes ? 'todos-os-lotes' : `${this.selecionados.length}-lotes`
        fileLink.setAttribute('download', `comprovantes-viagem-colaborador-${sufixo}.pdf`)
        document.body.appendChild(fileLink)
        fileLink.click()
        fileLink.remove()
        window.URL.revokeObjectURL(fileURL)
        // marca DEPOIS do download dar certo: marcar antes mentiria em cima de um 413
        this.registrarBaixados(this.todosOsLotes ? [] : this.selecionados)
      } catch (Error) {
        let msg = 'Não foi possível gerar o relatório.'
        const corpo = Error && Error.response && Error.response.data
        if (corpo && typeof corpo.text === 'function') {
          try {
            const texto = await corpo.text()
            if (texto) msg = texto.replace(/^"|"$/g, '')
          } catch (e) { /* fica a mensagem padrão */ }
        }
        toast.error(msg)
      } finally {
        loading.close()
      }
    },

    onLoad () {
      // this.collabId = this.$route.params.funcionarioId
      let param = new URLSearchParams(window.location.search)
      this.collabId = param.get('funcionario')
      // depois do collabId: a chave dos baixados inclui o funcionario
      this.carregarBaixados()
      this.getDetailsbyIds(this.collabId)
      // NAO chamar dataFormatadaPdf() aqui: o metodo nao existe neste componente (ZC-40).
      // Quem precisa da data formatada e o reportLotsPdf, e ele tem a propria copia e a chama
      // no proprio mounted -- a chamada aqui era copy-paste sem consumidor.
      //
      // O que ela causava, medido: 2 erros de console, e SO isso. Era a ULTIMA instrucao do
      // onLoad, depois de `getDetailsbyIds` (async, sem await) ja ter disparado a requisicao;
      // o `.then` que faz `LoadAllByData` e cadeia independente, o `mounted` proprio esta
      // vazio e o `ActionsForm.mounted` nao tem nada depois do onLoad. Ou seja: apagar isto
      // NAO faz linha aparecer na grid -- nao confundir com o vazio de um `?funcionario=`
      // recebendo id de lote.
    },
    async getDetailsbyIds (collabId) {
      loading.push()
      await TravelExpenseRepository.GetColaboratorTableTravelExpenseDetailsByFuncionarioId(collabId, this.CompanySelected, this.$refs.detailsTab.pagingLimit, this.$refs.detailsTab.pagingIndex)
        .then((Response) => {
          this.$refs.detailsTab.LoadAllByData(Response)
          this.$refs.refPdf.details = Response.data.data
          this.details = Response.data.data
          // sem filtro: `details` é o conjunto inteiro do colaborador
          this.filtroDeLoteAtivo = false
          this.registrarAnexosDeDetalhes()
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    showModal (partId) {
      this.partId = partId
      this.$refs['detailsModalRef'].show()
    },
    showModalPedido (detalhes) {
      this.loteId = detalhes.loteID
      this.funcionarioId = detalhes.funcionarioID
      this.PedidoGerado = false
      this.$refs['ModalGerarPedido'].show()
    },
    cancelPedido () {
      this.loteId = null
      this.$refs['ModalGerarPedido'].hide()
    },
    showModalPedidoGerado () {
      loading.push()
      TravelExpenseRepository.GerarPedido({LoteId: this.loteId, FuncionarioId: this.funcionarioId, EmpresaId: this.CompanySelected})
        .then((Response) => {
          this.pedido = Response.data
          loading.close()
          this.PedidoGerado = true
        })
        .catch((Error) => {
          toast.error('Erro ao gerar pedido!')
          loading.close()
          this.$refs['ModalGerarPedido'].hide()
        })
    },
    async filterTableByPartNumber (partNumber) {
      let inteiro = parseInt(partNumber)
      loading.push()
      await TravelExpenseRepository.GetColaboratorTableTravelExpenseDetailsByFuncionarioId(this.collabId, this.CompanySelected, this.$refs.detailsTab.pagingLimit, this.$refs.detailsTab.pagingIndex, { Lote: inteiro, Valor: 0 })
        .then((Response) => {
          this.details = Response.data.data
          // ZC-46: com filtro ligado `details` é um RECORTE. O modo "todos os lotes" manda
          // LoteIds: [] (= TODOS no backend) e não pode ser liberado medindo uma linha
          // filtrada. E `anexosPorLote` acumula, então a soma da seleção anterior não se
          // perde ao trocar `details`.
          this.filtroDeLoteAtivo = true
          this.registrarAnexosDeDetalhes()
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    GetEmpresa () {
      TravelExpenseRepository.GetEmpresa(this.CompanySelected)
        .then(Response => {
          this.local = Response.data.localidade
        })
    },
    async gerarPDF () {
      loading.push()
      await TravelExpenseRepository.GetReportColaboratorTableTravelExpenseDetailsByFuncionarioId(this.collabId, this.CompanySelected)
        .then((Response) => {
          loading.pop()
          this.detailsProp = Response.data.data
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
      this.$refs.refPdf.details = this.details
      // o slot do reportLotsPdf so renderiza depois que `detailsProp` chega (v-if la dentro);
      // sem o nextTick o generatePDF roda antes do DOM existir e o PDF sai vazio
      await this.$nextTick()
      this.$refs.refPdf.generatePDF()
    }
  },

  computed: {
    // Read-only quando vier da tela de consulta (CollaboratorTableTravelExpense passa consulta=1).
    // `consulta=1` nao pode ser a unica fonte -- e query string. Ver rolesEscritaViagem.js.
    isConsulta () {
      return derivaConsulta(this.$route.query, this.hasRole)
    }
  }
}
</script>

<template>
 <div>
    <div class="container-collab d-flex w-full h-full">
      <div class="col-md-3  w-full h-full">

      <filterForm @partNumber="filterTableByPartNumber($event)"/>
      </div>
      <div class="col-md-9">
        <!-- ZC-46 / task 026: `:pagingLimitDefault="1000"`, igual ao gemeo do Diversos.
             O default do Tables.vue e 10 (Tables.vue:242-244) e esta tela esconde o
             paginador (`:showPaging="false"`), entao o `pagingLimit` de 10 ia para a API e o
             colaborador via 10 lotes sem nada indicando que havia mais. Medido em producao:
             391 dos 821 funcionarios de Viagem tem mais de 10 lotes, pior caso 169. -->
        <Tables :stickyHeader="true" ref="detailsTab"
                  :columns="['Lote', 'Pedido','Nome Usuário','Função' ,'Obra','Início Viagem','Fim Viagem','Adiantamento','Anexos','Total Gastos','Impresso', '']"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  :newHeaderStatus="true"
                  :backPageLeft="true"
                  :showPaging="false"
                  :pagingLimitDefault="1000"
                  :showCheckInput="true"
                  v-on:check="marcarTodos"
                  v-on:Load="onLoad"
                  :key="0"
                >
                <template #return>
                    <div class="button-container" v-b-tooltip.hover title="Retornar">
                      <button type="button" v-on:click="$router.back()" class="btn btn-third btn-sm" ><i style="font-size:16px;padding-top:2px" class="fas fa-arrow-circle-left "></i></button>
                    </div>
                </template>
                <template #ButtonsAprova>
                  <!-- sem div extra: o Tables.vue ja envolve este slot num .Ajuste-Buton-Template
                       (Tables.vue:19), e aninhar outro deixava dois com o mesmo rect.
                       A classe `botao-relatorio-lotes` existe pra dar seletor ESTAVEL: mirar por
                       texto pegou o item "Relatorios" do Sidebar, porque o has-text do Playwright
                       e substring e case-insensitive. -->
                  <button type="button"
                          class="btn btn-third btn-sm botao-relatorio-lotes"
                          :disabled="!!motivoTetoRelatorio"
                          v-b-tooltip.hover
                          :title="motivoTetoRelatorio || `Gerar um PDF com ${todosOsLotes ? anexosTotais : anexosSelecionados} anexos de ${todosOsLotes ? details.length : selecionados.length} lote(s)`"
                          @click="gerarRelatorioSelecionados">
                    <i class="fa fa-file-pdf" style="font-size:14px"></i>
                    RELATÓRIO ({{ todosOsLotes ? details.length : selecionados.length }})
                    <span style="opacity:.85">· {{ todosOsLotes ? anexosTotais : anexosSelecionados }}/{{ tetoAnexos }} anexos</span>
                  </button>
                </template>
                  <tr v-for="(detail,index) in details" :key="index" >
                    <!-- ZC-46: `input type=checkbox` nativo, e não `b-form-checkbox`. O cabeçalho
                         desta grid usa input nativo (Tables.vue:69) e o `b-form-checkbox` vem dentro
                         de um `.custom-control` com padding próprio -- era isso que deixava a caixa
                         do corpo deslocada da do cabeçalho. -->
                    <TableColumn :IsCustom="true" :status="1">
                      <div class="celula-check" v-b-tooltip.hover :title="motivoLoteTravado(detail)">
                        <input type="checkbox"
                               :checked="todosOsLotes || selecionados.includes(detail.loteID)"
                               :disabled="!todosOsLotes && !podeMarcarLote(detail)"
                               @change="alternarLote(detail.loteID)">
                      </div>
                    </TableColumn>
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.lote"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.pedido"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.nome"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.funcao"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.obra"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataInicioViagem"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataFimViagem"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="formatMoney(detail.valorAdiantamento)"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <!-- ZC-46: `String(...)` de proposito. O TableColumn faz
                         `{{ (value) ? value : 'N/D' }}` (TableColumn.vue:5) e 0 e FALSY, entao
                         lote com ZERO comprovante saia escrito "N/D" -- escondendo exatamente a
                         informacao que o teto existe para dar. Visto no aceite nos lotes 10 e 18
                         do ADENILSON RIBEIRO ARAUJO. -->
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="String(detail.anexos || 0)"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="formatMoney(detail.valorTotalGastos)"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                localidade = detail.localidade;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <!-- ZC-46: SINALIZA que o relatório deste lote já foi baixado nesta sessão, e
                         NÃO impede baixar de novo -- o checkbox segue habilitado. Coluna própria
                         depois de Total Gastos, a pedido do Rodrigo; a coluna de ação (Pedido)
                         continua sendo a última. -->
                    <TableColumn :IsCustom="true" :status="1">
                      <div class="celula-impresso">
                        <i v-if="foiBaixado(detail.loteID)"
                           class="fas fa-check-circle text-success lote-ja-baixado"
                           v-b-tooltip.hover title="Relatório deste lote já baixado nesta sessão"></i>
                      </div>
                    </TableColumn>
                  <TableColumn
                  :IsOnlyPedido="!isConsulta && detail.codigoEmpresa === 8"
                  v-on:Pedido="showModalPedido(detail)"
                  />
                  </tr>
        </Tables>
      </div>
    </div>
    <b-modal
      centered hide-footer
      ref="detailsModalRef"
      :no-close-on-backdrop="true"
      title="Despesas"
      size="xl"
      >
      <details-modal
        :partId="partId"
        :partStartDate="partStartDate"
        :partEndDate="partEndDate"
        :partNumber ="partNumber"
        :collabId ="collabId"
        :localidade = "localidade"
        :totalPartValue="totalPartValue"
      />
    </b-modal>

    <b-modal
      centered hide-footer
      title="PEDIDO"
      ref="ModalGerarPedido"
      :no-close-on-backdrop="true"
      size="md"
      >
      <div v-if="PedidoGerado === false">
        <div class="flex">
          <i class="fas fa-file-invoice-dollar icon-pedido">
        </i></div>
        <div class="flex font-label">
          Deseja gerar o pedido ?
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">Cancelar</button>
            <button v-if="!isConsulta" @click="showModalPedidoGerado" class="button-save">GERAR</button>
        </div>
      </div>
      <div v-if="PedidoGerado === true">
        <div class="flex">
         <i class="fas fa-check-circle icon-pedido iconeSucesso"></i>
        </div>
        <div class="flex font-label">
        Gerado com Sucesso
        </div>

        <div class="flex font-label-menor">
         ORDEM DO PEDIDO
        </div>
        <div class="flex">
          <div class="font-label divPedido">
            {{pedido.data.itens[0].numPedidoGerado}}
          </div>
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">FECHAR</button>
        </div>
      </div>
    </b-modal>
    <reportLotsPdf ref="refPdf" :detailsProp="detailsProp"></reportLotsPdf>
 </div>
</template>

<style scoped>
/* ZC-46: as duas colunas de icone centradas, e o cabecalho junto. O `th` do check
   (Tables.vue:69) nao tem alinhamento proprio, entao vem do `::v-deep` daqui. */
.celula-check,
.celula-impresso {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 16px;
}
.celula-check input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}
.celula-check input[type="checkbox"]:disabled {
  cursor: not-allowed;
}
::v-deep thead th:first-child {
  text-align: center;
}
/* marca de "ja baixado nesta sessao" */
.lote-ja-baixado {
  font-size: 14px;
}

.divPedido {
  margin: 1rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: rgb(243, 243, 243);
  height: fit-content;
}
.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: #c40000;
  color: white;
}
.button-save{
  background-color: #008148;
  color: white;
}
.container-buttons-form{
  display: flex;
  justify-content: center;
  align-items: center;
  gap:15px;
}
.container-collab{
  justify-content: space-between;
}
.iconeSucesso {
  color: #008148;
}
.flex {
 display: flex;
 justify-content: center;
}
.icon-pedido{
  font-size: 60px;
  padding: 1rem
}
.font-label-menor{
  padding-top: 1rem;
 font-size: 13px;
}
.font-label{
 font-size: 16px;
 font-weight: bold;
}
.button-container{
  display: flex;
  align-items: center;
}
.button-container-download{
  display: flex;
  align-items: center;
  width: 3rem;
}
.button-back{
  width: 4rem;
  border-radius: 5px;
  background-color: #008148;
  color: #fff;
  border: 0;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/CollaboratorTableTravelExpenseEmploye.vue